// removed by extract-text-webpack-plugin
module.exports = {"lightPurple":"#e2c0f9","purple":"#9800ff","medium":"(min-width:768px)","medium-large":"(min-width:1024px)","easeInOutQuad":"cubic-bezier(.455,.03,.515,.955)","button":"circleButton__button___2jdT_","isActive":"circleButton__isActive___3Q8QZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CircleButton/circleButton.css
// module id = 157
// module chunks = 0